// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-table-dynamic{display:flex;flex-direction:column}.wl-table-dynamic .check-list{margin-bottom:15px}.wl-table-dynamic .table-list{flex:1;height:100%}.wl-table-dynamic .table-list th{text-align:center}", ""]);
// Exports
module.exports = exports;
